import { gql } from "@apollo/client";

export const QUERY_VIRTUAL_LOOPS_DATA = gql`
  query getVirtualLoopsData {
    getVirtualLoopsData {
      busy
      data {
        SSN
        data {
          real
          session
          driver
          lap
          lapTime
          powerMode
          goSwitch
          sLapDelta
          inLap
          outLap
          startTime
          virtualLoops {
            loopName
            loopTime
          }
        }
      }
      configLapData {
        vCar
        sLap
      }
      config {
        cornerConfig {
          cornerName
          cornerValue
        }
        path
        generation
      }
    }
  }
`;

export const SUBSCRIBE_VIRTUAL_LOOPS_DATA = gql`
  subscription newVirtualLoopsData {
    newVirtualLoopsData {
      busy
      data {
        SSN
        data {
          real
          session
          driver
          lap
          lapTime
          powerMode
          goSwitch
          sLapDelta
          inLap
          outLap
          startTime
          virtualLoops {
            loopName
            loopTime
          }
        }
      }
      configLapData {
        vCar
        sLap
      }
      config {
        cornerConfig {
          cornerName
          cornerValue
        }
        path
        generation
      }
    }
  }
`;

export const SET_VIRTUAL_LOOPS_CONFIG = gql`
  mutation setVirtualLoopsConfig(
    $virtualLoopsConfig: VirtualLoopsConfigInput!
  ) {
    setVirtualLoopsConfig(virtualLoopsConfig: $virtualLoopsConfig)
  }
`;

export const SET_VIRTUAL_LOOPS_LAP_REAL = gql`
  mutation setVirtualLoopsLapReal($lapReal: LapRealInput!) {
    setVirtualLoopsLapReal(lapReal: $lapReal)
  }
`;
